import { PseudoLocale, SupportedLocale } from "#/types/Locale"

// English labels are intentional (not native display names): they let internal users identify locales at a glance.
export const localeToggleOptions: { value: string; label: string }[] = [
  { value: SupportedLocale.English_UnitedStates.toString(), label: "English (U.S.)" },
  { value: SupportedLocale.English_UnitedArabEmirates.toString(), label: "English (UAE)" },
  { value: SupportedLocale.English_UnitedKingdom.toString(), label: "English (U.K.)" },
  { value: SupportedLocale.Spanish_UnitedStates.toString(), label: "Spanish (U.S.)" },
  { value: SupportedLocale.French_Canada.toString(), label: "French (Canada)" },
  { value: SupportedLocale.German_Germany.toString(), label: "German (Germany)" },
  { value: SupportedLocale.Portuguese_Brazil.toString(), label: "Portuguese (Brazil)" },
  { value: SupportedLocale.Hindi_India.toString(), label: "Hindi (India)" },
  { value: SupportedLocale.Thai_Thailand.toString(), label: "Thai (Thailand)" },
  { value: SupportedLocale.Turkish_Turkey.toString(), label: "Turkish (Turkey)" },
  { value: SupportedLocale.Italian_Italy.toString(), label: "Italian (Italy)" },
  { value: SupportedLocale.Spanish_Spain.toString(), label: "Spanish (Spain)" },
  { value: SupportedLocale.Serbian_Serbia.toString(), label: "Serbian (Serbia)" },
  { value: SupportedLocale.Dutch_Netherlands.toString(), label: "Dutch (Netherlands)" },
  { value: SupportedLocale.Romanian_Romania.toString(), label: "Romanian (Romania)" },
  { value: SupportedLocale.Polish_Poland.toString(), label: "Polish (Poland)" },
  { value: SupportedLocale.Spanish_Argentina.toString(), label: "Spanish (Argentina)" },
  { value: SupportedLocale.French_France.toString(), label: "French (France)" },
  { value: SupportedLocale.Georgian_Georgia.toString(), label: "Georgian (Georgia)" },
  { value: SupportedLocale.Greek_Greece.toString(), label: "Greek (Greece)" },
  { value: SupportedLocale.Hebrew_Israel.toString(), label: "Hebrew (Israel)" },
  { value: SupportedLocale.Japanese_Japan.toString(), label: "Japanese (Japan)" },
  { value: SupportedLocale.Kyrgyz_Kyrgyzstan.toString(), label: "Kyrgyz (Kyrgyzstan)" },
  { value: SupportedLocale.Russian_Russia.toString(), label: "Russian (Russia)" },
  { value: SupportedLocale.SimplifiedChinese_China.toString(), label: "Simplified Chinese (China)" },
  { value: SupportedLocale.TraditionalChinese_Taiwan.toString(), label: "Traditional Chinese (Taiwan)" },
  { value: SupportedLocale.BahasaIndonesia_Indonesia.toString(), label: "Bahasa Indonesia (Indonesia)" },
  { value: SupportedLocale.Vietnamese_Vietnam.toString(), label: "Vietnamese (Vietnam)" },
  { value: SupportedLocale.Arabic_UnitedArabEmirates.toString(), label: "Arabic (UAE)" },
  { value: SupportedLocale.Urdu_Pakistan.toString(), label: "Urdu (Pakistan)" },
  { value: PseudoLocale.PseudoAccented.toString(), label: "Pseudo: Accented" },
  { value: PseudoLocale.PseudoBidrectional.toString(), label: "Pseudo: Bidirectional" },
  { value: PseudoLocale.PseudoElongated.toString(), label: "Pseudo: Elongated" }
]
